import classTaipei from '../../image/trafficInfo/classTaipei.jpg';
import classHsinchu from '../../image/trafficInfo/classHsinchu.jpg';
import classTaichung from '../../image/trafficInfo/classTaichung.jpeg';
import classKaohsiung from '../../image/trafficInfo/classKaohsiung.jpg';
import classTaipeiIO from '../../image/trafficInfo/classTaipeiIO.png';
import classTaipeiDaVinCi from '../../image/trafficInfo/classTaipeiDaVinCi.png'

const trafficInfo = [
    {
        "id": "1",
        "class": "臺北班",
        "value": [
            {
                "text": "地點",
                "value": "TAF 臺北辦公室"
            },
            {
                "text": "地址",
                "value": "新北市淡水區中正東路二段 27 號 23 樓"
            },
            {
                "text": "電話",
                "value": "02-28090828"
            },
            {
                "text": "交通方式",
                "value": {
                    "word": "1. 搭乘捷運淡水線，往淡水方向，於紅樹林站下車，走 1 號出口，約 8 分鐘。 (台北火車站至紅樹林站約 40~50 分鐘)\n" +
                        "2. 自行開車者，附近停車場為紅樹林捷運站停車場，每小時 30 元。",
                    "photo": classTaipei,
                },
                "nextLine": true
            }
        ]
    },
    {
        "id": "2",
        "class": "臺北-進出口班",
        "value":[
            {
                "text": "地點",
                "value": "台北市進出口商業同業公會"
            },
            {
                "text": "地址",
                "value": "台北市中山區松江路350號（捷運行天宮站4號出口左轉100公尺）"
            },
            {
                "text":"交通方式",
                "value":{
                    "word":"捷運資訊：站名：「行天宮站」，由4號出口出站後左轉，步行約2分鐘即可到達。\n"+
                        "公車資訊：站名：民權松江路口（行天宮）\n" +
                        "1.(松江路)：26、41、49、63、72、105、109、113、203、214、222、225、226、279、280、290、松江－新生線、三重客運（長庚大學~行天宮）\n" +
                        "2.(民權東路)：5、33、41、49、63、214、225、285、505、527、612、617、642、801、敦化線、接駁公車－基河國宅",
                    "photo": classTaipeiIO
                },
                "nextLine": true
            }
        ]
    },
    {
        "id": "3",
        "class": "臺北-達文西空間",
        "value":[
            {
                "text": "地點",
                "value": "達文西空間"
            },
            {
                "text": "上課地點",
                "value": "台北市南京東路二段 6 號 6 樓（松江南京站1號出口-燦坤3C樓上）"
            },
            {
                "text": "交通方式",
                "value": {
                    "word":"捷運資訊：松江南京站(1號出口)，步行約6分鐘。\n"+
                        "公車資訊：南京吉林路口(公車路線：5、12、46、248、266區、282、282副、288區、292、292副、306、306區、307、604、605快、652、711、797、1501、1505、1802、1802A、1803、1815、承德幹線、南京幹線、紅25)",
                    "photo": classTaipeiDaVinCi
                },
                "nextLine": true
            }
        ]
    },
    {
        "id": "4",
        "class": "新竹班",
        "value": [
            {
                "text": "地點",
                "value": "TAF 新竹辦公室",
            },
            {
                "text": "地址",
                "value": "30044 新竹市北大路 95 號 2 樓",
            },
            {
                "text": "電話",
                "value": "03-5336333"
            },
            {
                "text": "備註",
                "value": {
                    "word": "請至本郵務大樓東大路警衛室旁之正門出入。",
                    "photo": classHsinchu
                }
            },
            {
                "text": "交通資訊",
                "value": "1. 搭乘台鐵：\n" +
                    "\t火車站至新竹辦公室的步行路線-- 火車站下車後穿過中華路，沿中正路向前走至北大路右轉，續向前行穿過東大路，右手邊即為郵務大樓，本會位於該大樓二樓；步行時間約 15 至 20 分鐘。\n" +
                    "2. 搭乘高鐵：\n" +
                    "\t新竹高鐵下車後可搭乘台鐵六家支線至新竹火車站，到達後請參考第１項之步行路線。或搭乘國光客運由新竹高鐵站至東門市場之 1782 路線，至北大教堂站下車 (本路線僅能下車，不能上車)，續向東大路方向步行，穿過東大路即抵達。\n" +
                    "3. 竹市公車：\n" +
                    "\t1. 竹市免費公車 55 路 (南寮-竹科)，於「文化中心」下車，至北大路穿過東大路即抵達。\n" +
                    "\t2. 竹市 16 路公車-新竹火車站至台大醫院新竹分院，於「水利局」下車即抵達。尖峰時段約 20 分鐘一班，離峰時段約 40 分鐘至 1 小時一班。\n" +
                    "3. 自行開車:\n" +
                    "\t高速公路至新竹交流道下，沿光復路朝西向市區直行，上高架路轉東大路，行至第 1 出口處 (民族路口)，下高架路繼續往前之慢車道行駛至北大路右轉 20 公尺，右手邊即為郵務大樓，本會位於該大樓二樓。 附近停車場為P1－「文化中心演藝廳停車場」、P2－「北大路公有小型車停車場」、P3－「府後街公有停車場」、P4－「東大路橋停車場」。 (每小時均為 20 元)",
                "nextLine": true
            }
        ]
    },
    {
        "id": "5",
        "class": "臺中班",
        "value": [
            {
                "text": "地址",
                "value": "台中市南屯區公益路二段 51 號 19 樓 (國泰人壽公益大樓)",
            },
            {
                "text": "電話",
                "value": "04-2327-7598"
            },
            {
                "text": "傳真",
                "value": "04-2327-1815"
            },
            {
                "text": "參考網址",
                "value": {
                    "href": "http://www.cmoney.com.tw/cmweb/tc.html"
                }
            },
            {
                "text": "大眾交通工具",
                "value": "台中市公車 23 . 72 . 107 皆可到達，下車站牌 -- 公益東興路口\n" +
                    "從台中火車站可搭乘 27 號公車往嶺東科技大學，下車站牌 -- 公益東興路口\n" +
                    "台中火車站可搭乘 81 號公車往統聯轉運站，下車站牌 -- 公益東興路口\n" +
                    "綠川東站可搭乘 70 號往嶺東科技大學，下車站牌 -- 公益東興路口\n" +
                    "後火車站可搭乘 60 號往坪頂，下車站牌 -- 大墩公益路口\n" +
                    "從秋紅谷可搭 60 號公車往大智公園，下車站牌 -- 大墩公益路口\n" +
                    "從統聯轉運站可搭乘 81 號公車往太平，下車站牌 -- 公益東興路口",
                "nextLine": true
            },
            {
                "text": "停車場 (費用如有變動依停車場收費為準)",
                "value": {
                    "word": "本大樓附設地下停車場 (B3)，平日 30 元 / 小時，假日 40 元 / 小時、平日一天上限 200 元\n" +
                        "台灣聯通大墩 11 街入口，平日 15 元 / 半小時，假日 20 元 / 半小時\n" +
                        "台灣聯通大昌街入口，30 元 / 小時 (不分平假日)\n" +
                        "大新停車場，10 元 / 半小時 (不分平假日)\n" +
                        "後火車站可搭乘 60 號往坪頂，下車站牌 -- 大墩公益路口\n" +
                        "來來停車場，平日下午 5:30 前 20 元 / 小時，下午 5:30 過後與假日 30 元 / 小時\n" +
                        "從公益路停車場，40 元 / 小時 (不分平假日)\n" +
                        "其餘停車場皆為，20 元 / 半小時 (不分平假日)",
                    "photo": classTaichung,
                },
                "nextLine": true
            }
        ]
    },
    {
        "id": "6",
        "class": "高雄班",
        "value": [
            {
                "text": "地點",
                "value": "中華民國對外貿易發展協會高雄辦事處"
            },
            {
                "text": "地址",
                "value": "高雄市民權一路 28 號 4~5 樓 (民權一路與興中一路口第一銀行樓上)"
            },
            {
                "text": "電話",
                "value": "07-336-3113"
            },
            {
                "text": "參考網址",
                "value": {
                    "href": "https://kh.taiwantrade.com/note/detail?id=1842"
                }
            },
            {
                "text": "備註",
                "value": {
                    "word": "課程舉辦地點如有異動,將另行通知 (以課程需知為準)",
                    "photo": classKaohsiung
                }
            },
            {
                "text": "停車場資訊",
                "value": "高雄市政府旁四維立體停車場 (走路約 15 分鐘)\n" +
                    "收費：1 小時 20 元 (費用如有變動依停車場收費為準)",
                "nextLine": true
            },
            {
                "text": "公車資訊",
                "value": "69 路公車：火車站前搭乘至市政大樓。\n" +
                    "捷運資訊：搭乘至三多商圈 (R8) 站步行：由第 6 出入口出站，右轉興中路，直行過民權路第一銀行樓上 (步行約 20~25 分鐘)。\n" +
                    "轉乘公車：100 路公車、70 路公車、紅 16 路公車\n" +
                    "由第 4 出入口出站，步行至 SOGO 百貨及新光三越百貨搭乘，至三多市場站下車。\n" +
                    "外縣市自行開車：由 1 號國道下中正交流道，沿著邊坡便道至三多路右轉 (勿轉中正路)，直行至民權路右轉。\n" +
                    "參考網站：中華民國對外貿易發展協會高雄辦事處",
                "nextLine": true
            }
        ]
    }
];

export default trafficInfo;